import { fileTextIcon, paletteIcon, penRulerIcon, settingsIcon, brushIcon,CalibartionIcon, TrainingIcon ,PrioIcon, ServiceIcon,CheckListIcon, MaintenanceIcon, CustomerEvaluationIcon} from "./menuIcons";

export const menuItems = [
  {
    title: 'Priority',
    id: '1',
    icon: PrioIcon,
    permission: ['access priorities', 'edit priorities', 'access priorities-setup'],
    children: [
      {
        title: 'Menu.Priorities.ZoznamPriorit',
        id: '1_1',
        page: 'PriorityList',
        mask: 'prio001'
      },
      {
        title: 'Menu.Priorities.ZoznamPrioritMaly',
        id: '1_2',
        page: 'PriorityListMobile',
        mask: 'prio002'
      },
      {
        title: 'Menu.Priorities.ManualnaPriorita',
        id: '1_3',
        page: 'PriorityAdd',
        permission: 'edit priorities',
        mask: 'prio003'
      },
      {
        title: 'Common.Settings',
        id: '1_4',
        permission: 'access priorities-setup',
        children: [
          {
            title: 'Menu.Priorities.OddeleniaPriorit',
            id: '1_4_1',
            page: 'PriorityDepartmentList',
            mask: 'prio004',  //add - prio007
          },
          {
            title: 'Menu.Priorities.NastAutPriorit',
            id: '1_4_2',
            page: 'PriorityLoadAutomaticList',
            mask: 'prio005', //add prio008
          },
          {
            title: 'Menu.Priorities.NastManPriorit',
            id: '1_4_3',
            page: 'PriorityLoadManuallyList',
            mask: 'prio006',
          },
        ],
      }
    ],
  },
  {
    title: 'OTK',
    id: '2',
    icon: penRulerIcon,
    permission: ['access otk-section1', 'access otk-section2', 'access otk-section3', 'access otk-documentation', 'access otk-company', 'access otk-statistics', 'access otk-setup'],
    children: [
      {
        title: 'Menu.OTK.NahladKvality',
        id: '2_1',
        page: 'PreviewOTK',
        mask: 'qlty001'
      },
      {
        title: 'Menu.OTK.InternaChyba',
        id: '2_2',
        page: 'ZoznamInt',
        mask: 'qlty002'
        //add 03
      },
      {
        title: 'Menu.OTK.ExternaChyba',
        id: '2_3',
        page: 'ZoznamExt',
        mask: 'qlty004'
        //add 05
      },
      {
        title: 'Menu.OTK.Reklamacia',
        id: '2_4',
        page: 'ZoznamRek',
        mask: 'qlty006'
        //add 07
      },
      {
        title: 'Menu.OTK.Fotodokumentacia',
        id: '2_5',
        permission: 'access otk-documentation',
        children: [
          {
            title: 'Menu.OTK.Dokumentacia',
            id: '2_5_1',
            page: 'Documentation',
            mask: 'qlty008'
            //add 09
            //edit 10
          },
          {
            title: 'Menu.OTK.MeraciProtokol',
            id: '2_5_2',
            page: 'MeasurementProtocol',
            mask: 'qlty011'
          },
          {
            title: 'Menu.OTK.Sebakontrola',
            id: '2_5_3',
            page: 'SelfControl',
            mask: 'qlty012'
          },
          {
            title: 'NDT Protokol',
            id: '2_5_4',
            page: 'NDTProtocol',
            mask: 'qlty013'
          },
          {
            title: 'Menu.OTK.ZihaciProtokol',
            id: '2_5_5',
            page: 'AnnealingProtocol',
            mask: 'qlty014'
          },
        ],
      },
      {
        title: 'Menu.OTK.ObchodniPartneri',
        id: '2_12',
        permission: 'access otk-company',
        children: [
          {
            title: 'Menu.OTK.KartyPartnerov',
            page: 'OtkCompanyCertificateList',
            id: '2_12_1',
            mask:'qlty026' //add 27
          },
          {
            title: 'Menu.OTK.DokumentaciePartnerov',
            page: 'OtkCompanyCardList',
            id: '2_12_1b',
            mask:'qlty032'
          },
          {
            title: 'Menu.OTK.PlatnostiDokumentacii',
            id: '2_12_2',
            children: [
              {
                title: 'Menu.OTK.PodlaFirmy',
                page: 'OtkCompanyCertRecordList',
                id: '2_12_2_1',
                mask:'qlty028' //detail 29
              },
              {
                title: 'Menu.OTK.PodlaStavu',
                page: 'OtkCompanyCertStateList',
                id: '2_12_2_2',
                mask:'qlty030'
              },
              {
                title: 'Menu.OTK.PridatDokumentaciu',
                page: 'OtkCompanyCertRecordAdd',
                id: '2_12_2_3',
                mask:'qlty031'
              },
            ]
          }
        ],
      },
      {
        title: 'Menu.OTK.Statistika',
        id: '2_11',
        permission: 'access otk-statistics',
        children: [
          {
            title: 'Menu.OTK.Vystup',
            id: '2_11_1',
            page: 'OTKStatistics',
            mask: 'qlty015'
          },
          {
            title: 'Menu.OTK.Vyhodnotenie',
            id: '2_11_2',
            page: 'OTKEvaluation',
            mask: 'qlty042'
          },
        ],
      },
      {
        title: 'Common.Settings',
        id: '2_10',
        permission: 'access otk-setup',
        children: [
          {
            title: 'Menu.OTK.Vseobecne',
            id: '2_10_0',
            page: 'OtkGeneralSettings',
            mask: 'qlty041'
          },
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '2_10_6',
            page: 'SummaryEmailOTKList',
            mask: 'qlty024'
            //add,edit 025
          },
          {
            title: 'Menu.OTK.DruhChyby',
            id: '2_10_1',
            page: 'ErrorTypeList',
            mask: 'qlty016'
            //add,edit 017
          },
          {
            title: 'Menu.OTK.KorenovaPricina',
            id: '2_10_2',
            page: 'RootCauseList',
            mask: 'qlty034'
            //add,edit 035
          },
          {
            title: 'Menu.OTK.Skupina',
            id: '2_10_3',
            page: 'GroupList',
            mask: 'qlty018'
            //add,edit 019
          },
          {
            title: 'Menu.OTK.Zabranenie',
            id: '2_10_4',
            page: 'PreventionList',
            mask: 'qlty020'
            //add,edit 021
          },
          {
            title: 'Menu.OTK.NarocnostDielu',
            id: '2_10_5',
            page: 'MeasureComplexityList',
            mask: 'qlty022'
            //add,edit 023
          },
          {
            title: 'Menu.OTK.DruhProtokolu',
            id: '2_10_8',
            page: 'ProtocolTypeList',
            mask: 'qlty038'
            //add,edit 039
          },
          {
            title: 'Menu.OTK.Statistiky',
            id: '2_10_7',
            page: 'OtkStatisticsSettings',
            mask: 'qlty040'
          },
        ],
      }
    ],
  },
  {
    title: 'Menu.Painting.Root',
    id: '3',
    icon: brushIcon,
    permission: ['access painting', 'access painting-setup'],
    children: [
      {
        title: 'Menu.Painting.NahladLakovne',
        id: '3_1',
        page: 'PreviewLak',
        mask:'pain001'
      },
      {
        title: 'Menu.Painting.PodmienkyLakovania',
        id: '3_2',
        page: 'PaintingConditionList',
        mask:'pain002'
      },
      {
        title: 'Common.Settings',
        id: '3_3',
        permission: 'access painting-setup',
        children: [
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '3_3_5',
            page: 'SummaryEmailPaintingList',
            mask:'pain012'
          },
          {
            title: 'Menu.Painting.CasovePodmienky',
            id: '3_3_1',
            page: 'PaintingTimeConditionList',
            mask:'pain004'
          },
          {
            title: 'Menu.Painting.UpozorneniaUzivatelom',
            id: '3_3_2',
            page: 'PaintingEmployeeConditionList',
            mask:'pain006'
          },
          {
            title: 'Menu.Painting.Intervaly',
            id: '3_3_3',
            page: 'PaintingIntervalList',
            mask:'pain008'
          },
          {
            title: 'Menu.Painting.Pocasie',
            id: '3_3_4',
            page: 'WeatherList',
            mask:'pain010'
          },
        ],
      },
    ],
  },
  {
    title: 'Menu.Calibration.Root',
    id: '4',
    icon: CalibartionIcon,
    permission: ['access calibration', 'access calibration-company', 'access calibration-setup'],
    children: [
      {
        title: 'Menu.Calibration.NahladKalibracii',
        id: '4_1',
        page: 'PreviewCal',
        mask:'calb001'
      },
      {
        title: 'Menu.Calibration.ZoznamMeradiel',
        id: '4_2',
        page: 'GaugeList',
        mask:'calb002'
      },
      {
        title: 'Menu.Calibration.ZoznamKalibracii',
        id: '4_3',
        children: [
          {
            title: 'Menu.Calibration.PodlaMeradla',
            id: '4_3_1',
            page: 'GaugeCalibrationList',
            mask: 'calb004'
          },
          {
            title: 'Menu.OTK.PodlaStavu',
            id: '4_3_2',
            page: 'CalibrationStateList',
            mask: 'calb015'
          },
        ],
      },
      {
        title: 'Menu.Calibration.KalibracneFirmy',
        id: '4_4',
        permission: 'access calibration-company',
        children: [
          {
            title: 'Menu.Calibration.KartyFiriem',
            id: '4_4_1',
            page: 'CalibrationCompanyCertificateList',
            mask:'calb008'
          },
          {
            title: 'Menu.Calibration.CertifikatyFiriem',
            id: '4_4_1b',
            page: 'CalibrationCompanyCardList',
            mask:'calb032'
          },
          {
            title: 'Menu.Calibration.PlatnostiCertifikatov',
            id: '4_4_2',
            children: [
              {
                title: 'Menu.OTK.PodlaFirmy',
                page: 'CalibrationCompanyCertRecordList',
                id: '4_4_2_1',
                mask:'calb010' //detail 11 add12
              },
              {
                title: 'Menu.OTK.PodlaStavu',
                page: 'CalibrationCompanyCertStateList',
                id: '4_4_2_2',
                mask:'calb013'
              },
              {
                title: 'Menu.Calibration.ZaznamenatCertifikat',
                page: 'CalibrationCompanyCertRecordAdd',
                id: '4_4_2_3',
                mask:'calb012'
              },
            ]
          },
        ],
      },
      {
        title: 'Common.Settings',
        id: '4_5',
        permission: 'access calibration-setup',
        children: [
          {
            title: 'Menu.OTK.Vseobecne',
            id: '4_5_0',
            page: 'CalibrationGeneralSettings',
            mask: 'calb016'
          },
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '4_5_1',
            page: 'SummaryEmailCalibrationList',
            mask:'calb014'
          },
        ],
      },
    ],
  },
  {
    title: 'Menu.Checklists.Root',
    id: '8',
    icon: CheckListIcon,
    permission: ['access checklists', 'edit checklists', 'access checklists-complete-list', 'access checklists-setup'],
    children: [
      {
        title: 'Menu.Checklists.NahladChecklistov',
        page: 'PreviewChecklists',
        id: '8_1',
        mask: 'chck014',
      },
      {
        title: 'Menu.Checklists.NovyZaznam',
        page: 'ChecklistRecordList',
        id: '8_2',
        mask:'chck003', //add 004
        permission: 'add checklists',
      },
      {
        title: 'Menu.Checklists.ZoznamChecklistov',
        page: 'ChecklistRecordMyList',
        id: '8_3',
        mask:'chck009' //detail 010
      },
      {
        title: 'Menu.Checklists.VyjadreniaVeducich',
        page: 'ChecklistStateList',
        id: '8_4',
        mask:'chck005', //detail 006
        permission: 'edit checklists',
      },
      {
        title: 'Menu.Checklists.UplnyZoznam',
        page: 'ChecklistRecordAllList',
        id: '8_5',
        mask:'chck011', //detail 012
        permission: 'access checklists-complete-list',
      },
      {
        title: 'Common.Settings',
        id: '8_6',
        permission: 'access checklists-setup',
        children: [
          {
            title: 'Menu.OTK.Vseobecne',
            id: '8_6_0',
            page: 'ChecklistGeneralSettings',
            mask: 'chck015'
          },
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '8_6_3',
            page: 'SummaryEmailChecklistList',
            mask:'chck007' //add 008
          },
          {
            title: 'Menu.Checklists.SablonyChecklistov',
            id: '8_6_1',
            page: 'ChecklistTemplateList',
            mask:'chck002' // add 001
          },
        ],
      },
    ],
  },
  {
    title: 'Menu.Training.Root',
    icon: TrainingIcon,
    id: '5',
    permission: ['access training', 'access training-company', 'access training-invitation', 'access training-setup'],
    children: [
      {
        title: 'Menu.Training.NahladSkoleni',
        page: 'PreviewTraining',
        id: '5_1',
        mask:'trng001'
      },
      {
        title: 'Menu.Training.KartyZamestnancov',
        page: 'TrainingCardList',
        id: '5_2',
        mask:'trng002' //add 003 //detail 004
      },
      {
        title: 'Menu.Training.TypySkoleni',
        id: '5_3',
        page: 'TrainingTypeList',
        mask:'trng005' //add 006
      },
      {
        title: 'Menu.Training.SablonySkoleni',
        id: '5_4',
        children: [
          {
            title: 'Menu.Training.ZoznamSablon',
            id: '5_4_1',
            page: 'TrainingTemplateList',
            mask:'trng007' //add 008
          },
          {
            title: 'Menu.Training.PriradenieSkoleni',
            id: '5_4_2',
            page: 'TrainingTemplateRecordList',
            mask:'trng009' //add 010
          },
        ],
      },
      {
        title: 'Menu.Training.ZoznamSkoleni',
        id: '5_5',
        children: [
          {
            title: 'Menu.Training.PodlaZamestnanca',
            page: 'TrainingRecordList',
            id: '5_5_1',
            mask:'trng011' //add 012 nizsie //detail 13
          },
          {
            title: 'Menu.Training.PodlaSkolenia',
            page: 'TrainingEmployeeList',
            id: '5_5_2',
            mask:'trng014' //detail 015
          },
          {
            title: 'Menu.OTK.PodlaStavu',
            page: 'TrainingStateList',
            id: '5_5_3',
            mask:'trng016'
          },
          {
            title: 'Menu.Training.ZaznamenatSkolenie',
            page: 'TrainingRecordAdd',
            id: '5_5_4',
            mask:'trng012'
          },
        ],
      },
      {
        title: 'Menu.Training.SkoliaceFirmy',
        id: '5_7',
        permission: 'access training-company',
        children: [
          {
            title: 'Menu.Calibration.KartyFiriem',
            id: '5_7_1',
            page: 'TrainingCompanyCertificateList',
            mask: 'trng021'
          },
          {
            title: 'Menu.Training.SkoliteliaFiriem',
            id: '5_7_1c',
            page: 'TrainingCompanyContactList',
            mask: 'trng019'
          },
          {
            title: 'Menu.Calibration.CertifikatyFiriem',
            id: '5_7_1b',
            page: 'TrainingCompanyCardList',
            mask: 'trng017'
          },
          {
            title: 'Menu.Calibration.PlatnostiCertifikatov',
            id: '5_7_2',
            children: [
              {
                title: 'Menu.OTK.PodlaFirmy',
                page: 'TrainingCompanyCertRecordList',
                id: '5_7_2_1',
                mask: 'trng023'
              },
              {
                title: 'Menu.OTK.PodlaStavu',
                page: 'TrainingCompanyCertStateList',
                id: '5_7_2_2',
                mask: 'trng026'
              },
              {
                title: 'Menu.Calibration.ZaznamenatCertifikat',
                page: 'TrainingCompanyCertRecordAdd',
                id: '5_7_2_3',
                mask: 'trng024'
              },
            ]
          },
        ],
      },
      {
        title: 'Menu.Training.Pozvanky',
        id: '5_8',
        permission: 'access training-invitation',
        children: [
          {
            title: 'Menu.Training.Invitations.List',
            tabName: 'Menu.Training.ZoznamPozvanok',
            page: 'TrainingInvitationList',
            id: '5_8_1',
            mask:'trng027' //add 28
          },
          {
            title: 'Menu.Training.Invitations.Templates',
            tabName: 'Menu.Training.VzoryPozvanok',
            page: 'TrainingInvitationTemplateList',
            id: '5_8_2',
            mask:'trng029' //add 30
          },
        ],
      },
      {
        title: 'Common.Settings',
        id: '5_9',
        permission: 'access training-setup',
        children: [
          {
            title: 'Menu.OTK.Vseobecne',
            id: '5_9_2',
            page: 'TrainingGeneralSettings',
            mask:'trng033'
          },
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '5_9_1',
            page: 'SummaryEmailTrainingList',
            mask:'trng031' //add 32
          },
          {
            title: 'Menu.Training.Lektori',
            id: '5_9_2',
            page: 'LecturerList',
            mask:'trng034'
          },
        ],
      },
    ],
  },
  {
    title: 'Menu.Maintenance.Root',
    id: '9',
    icon: MaintenanceIcon,
    permission: ['access maintenance', 'access maintenance-company', 'access maintenance-setup'],
    children: [
      {
        title: 'Menu.Maintenance.NahladUdrzby',
        page: 'PreviewMaintenance',
        id: '9_10',
        mask:'mntn040'
      },
        {
          title: 'Menu.Maintenance.KartyStrojov',
          page: 'MaintenanceCardList',
          id: '9_7',
          mask:'mntn015' //add 016 //detail 017
        },
        {
          title: 'Menu.Maintenance.VypadkyStrojov',
          page: 'MaintenanceMachineStateList',
          id: '9_11',
          mask:'mntn037' //detail mnt038
        },
        {
          title: 'Menu.Maintenance.TypyUkonov',
          page: 'MaintenanceTypeList',
          id: '9_1',
          mask:'mntn001' //add 002
        },
        {
          title: 'Menu.Maintenance.SablonyUkonov',
          id: '9_2',
          children: [
            {
              title: 'Menu.Training.ZoznamSablon',
              id: '9_2_1',
              page: 'MaintenanceTemplateList',
              mask:'mntn011' //add 012
            },
            {
              title: 'Menu.Maintenance.PriradenieUkonov',
              id: '9_2_2',
              page: 'MaintenanceTemplateRecordList',
              mask:'mntn013' //add 014
            },
          ],
        },
        {
          title: 'Menu.Maintenance.PlanovaneUkony',
          id: '9_4',
          children: [
            {
              title: 'Menu.Maintenance.UkonyPodlaStroja',
              page: 'MaintenanceRecordList',
              id: '9_4_1',
              mask:'mntn018' //add 019 nizsie //detail 020
            },
            {
              title: 'Menu.Maintenance.ZoznamPodlaUkonu',
              page: 'MaintenanceMachineList',
              id: '9_4_2',
              mask:'mntn021' //detail 022
            },
            {
              title: 'Menu.Maintenance.ZoznamPodlaStavu',
              page: 'MaintenanceStateList',
              id: '9_4_3',
              mask:'mntn023'
            },
            {
              title: 'Menu.Maintenance.ZaznamenatUkon',
              page: 'MaintenanceRecordAdd',
              id: '9_4_4',
              mask:'mntn019'
            },
          ],
        },
        {
          title: 'Menu.Maintenance.ZoznamPoruch',
          id: '9_5',
          children: [
            {
              title: 'Menu.Maintenance.PodlaStroja',
              page: 'MaintenanceTaskRecordList',
              id: '9_5_1',
              mask:'mntn024' //detail 025
            },
            {
              title: 'Menu.OTK.PodlaStavu',
              page: 'MaintenanceTaskStateList',
              id: '9_5_2',
              mask:'mntn026'
            },
          ],
        },
        {
          title: 'Menu.Maintenance.ZoznamNakupov',
          id: '9_8',
          children: [
            {
              title: 'Menu.Maintenance.PodlaStroja',
              page: 'MaintenanceNeedRecordList',
              id: '9_8_1',
              mask:'mntn030' //detail 031
            },
            {
              title: 'Menu.OTK.PodlaStavu',
              page: 'MaintenanceNeedStateList',
              id: '9_8_2',
              mask:'mntn032'
            },
          ],
        },
        {
          title: 'Menu.Maintenance.ChecklistyStrojov',
          id: '9_6',
          children: [
            {
              title: 'Menu.Maintenance.PodlaStroja',
              page: 'MaintenanceCheckRecordList',
              id: '9_6_1',
              mask:'mntn027' //detail 028
            },
            {
              title: 'Menu.OTK.PodlaStavu',
              page: 'MaintenanceCheckStateList',
              id: '9_6_2',
              mask:'mntn029'
            },
          ],
        },
        {
        title: 'Menu.Maintenance.ServisneFirmy',
        id: '9_3',
        permission: 'access maintenance-company',
        children: [
          {
            title: 'Menu.Calibration.KartyFiriem',
            id: '9_3_1',
            page: 'MaintenanceCompanyCardList',
            mask: 'mntn036'
          },
          {
            title: 'Menu.Maintenance.ServisniTechniciFiriem',
            id: '9_3_3',
            page: 'MaintenanceCompanyContactList',
            mask: 'mntn003'
          },
          {
            title: 'Menu.Calibration.CertifikatyFiriem',
            id: '9_3_2',
            page: 'MaintenanceCompanyCertificateList',
            mask: 'mntn005'
          },
          {
            title: 'Menu.Calibration.PlatnostiCertifikatov',
            id: '9_3_4',
            children: [
              {
                title: 'Menu.OTK.PodlaFirmy',
                page: 'MaintenanceCompanyCertRecordList',
                id: '9_3_4_1',
                mask: 'mntn007'
              },
              {
                title: 'Menu.OTK.PodlaStavu',
                page: 'MaintenanceCompanyCertStateList',
                id: '9_3_4_2',
                mask: 'mntn010'
              },
              {
                title: 'Menu.Calibration.ZaznamenatCertifikat',
                page: 'MaintenanceCompanyCertRecordAdd',
                id: '9_3_4_3',
                mask: 'mntn008'
              },
            ]
          },
        ],
      },
      {
        title: 'Common.Settings',
        id: '9_9',
        permission: 'access maintenance-setup',
        children: [
          {
            title: 'Menu.OTK.Vseobecne',
            id: '9_9_2',
            page: 'MaintenanceGeneralSettings',
            mask:'mntn035'
          },
          {
            title: 'Menu.OTK.EmailoveReporty',
            id: '9_9_1',
            page: 'SummaryEmailMaintenanceList',
            mask:'mntn033' //add 34
          },
        ],
      },
    ],
  },
  {
    title: 'Menu.CRM.Root',
    id: '10',
    icon: CustomerEvaluationIcon,
    permission: ['access customer_management', 'access customer_management-complete-list', 'access customer_management-setup'],
    children: [
      {
        title: 'Menu.CRM.Statistics',
        id: '10_1',
        permission: 'access customer_management',
        children: [
          {
            title: 'Menu.CRM.EvaluationCustomers',
            id: '10_1_1',
            page: 'CustomerEvaluationList',
            permission: 'access customer_management',
            mask: 'cust001',
          },
          {
            title: 'Menu.CRM.ProductionQuality',
            id: '10_1_2',
            page: 'CustomerProductionQuality',
            permission: 'access customer_management',
            mask: 'cust004',
          },
        ],
      },
      {
        title: 'Menu.CRM.TraderEvaluation',
        id: '10_5',
        page: 'CustomerSalesEvaluation',
        permission: 'access customer_management',
        mask: 'cust005',
      },
      {
        title: 'Menu.CRM.CentralDatabase',
        id: '10_6',
        page: 'CustomerCentralDatabaseList',
        permission: 'access customer_management',
        mask: 'cust011', // add/detail cez CustomerCentralDatabaseAdd -> cust012
      },
      {
        title: 'CustomerMyCustomersList.Title',
        id: '10_7',
        page: 'CustomerMyCustomersList',
        permission: 'access customer_management',
        mask: 'cust013', // detail cez CustomerMyCustomersDetail -> cust014
      },
      {
        title: 'CustomerAllPartnersList.Title',
        id: '10_9',
        page: 'CustomerAllPartnersList',
        permission: 'access customer_management-complete-list',
        mask: 'cust016', // detail cez CustomerAllPartnersDetail -> cust017
      },
      {
        title: 'Menu.CRM.MyBusiness',
        id: '10_10',
        permission: 'access customer_management',
        children: [
          {
            title: 'Menu.CRM.MyBusiness.ByCustomer',
            id: '10_10_1',
            page: 'CustomerMyBusinessByCustomerList',
            permission: 'access customer_management',
            mask: 'cust025', // detail -> cust026
          },
          {
            title: 'Menu.CRM.MyBusiness.ByState',
            id: '10_10_2',
            page: 'CustomerMyBusinessByStateList',
            permission: 'access customer_management',
            mask: 'cust027', // detail -> cust020
          },
        ],
      },
      {
        title: 'Menu.CRM.AllBusiness',
        id: '10_11',
        permission: 'access customer_management-complete-list',
        children: [
          {
            title: 'Menu.CRM.AllBusiness.ByCustomer',
            id: '10_11_1',
            page: 'CustomerAllBusinessByCustomerList',
            permission: 'access customer_management-complete-list',
            mask: 'cust028', // detail -> cust029
          },
          {
            title: 'Menu.CRM.AllBusiness.ByState',
            id: '10_11_2',
            page: 'CustomerAllBusinessByStateList',
            permission: 'access customer_management-complete-list',
            mask: 'cust030', // detail -> cust020
          },
        ],
      },
      {
        title: 'Menu.CRM.MyAcquisitions',
        id: '10_12',
        permission: 'access customer_management',
        children: [
          {
            title: 'Menu.CRM.MyAcquisitions.ByCustomer',
            id: '10_12_1',
            page: 'CustomerMyAcquisitionByCustomerList',
            permission: 'access customer_management',
            mask: 'cust031', // detail -> cust032
          },
          {
            title: 'Menu.CRM.MyAcquisitions.ByState',
            id: '10_12_2',
            page: 'CustomerMyAcquisitionByStateList',
            permission: 'access customer_management',
            mask: 'cust033', // detail -> cust020
          },
        ],
      },
      {
        title: 'Menu.CRM.AllAcquisitions',
        id: '10_13',
        permission: 'access customer_management-complete-list',
        children: [
          {
            title: 'Menu.CRM.AllAcquisitions.ByCustomer',
            id: '10_13_1',
            page: 'CustomerAllAcquisitionByCustomerList',
            permission: 'access customer_management-complete-list',
            mask: 'cust034', // detail -> cust035
          },
          {
            title: 'Menu.CRM.AllAcquisitions.ByState',
            id: '10_13_2',
            page: 'CustomerAllAcquisitionByStateList',
            permission: 'access customer_management-complete-list',
            mask: 'cust036', // detail -> cust020
          },
        ],
      },
      {
        title: 'Menu.CRM.Communication',
        id: '10_8',
        permission: 'access customer_management',
        children: [
          {
            title: 'Menu.CRM.Communication.Preview',
            id: '10_8_4',
            page: 'PreviewCrmCommunication',
            permission: 'access customer_management',
            mask: 'cust022',
          },
          {
            title: 'Menu.CRM.Communication.NewTask',
            id: '10_8_1',
            page: 'CrmCommunicationNewTaskHub',
            permission: 'access customer_management',
            mask: 'cust015',
          },
          {
            title: 'Menu.CRM.Communication.MyAgenda',
            id: '10_8_2',
            page: 'CrmCommunicationMyAgendaList',
            permission: 'access customer_management',
            mask: 'cust019',
          },
          {
            title: 'Menu.CRM.Communication.CompleteList',
            id: '10_8_3',
            page: 'CrmCommunicationCompleteList',
            permission: 'access customer_management-complete-list',
            mask: 'cust021',
          },
        ],
      },
      // {
      //   title: 'Menu.CRM.UplnyZoznam',
      //   id: '10_3',
      //   page: 'CustomerEvaluationCompleteList',
      //   permission: 'access customer_management-complete-list',
      //   mask: 'cust002',
      // },
      {
        title: 'Menu.CRM.Settings',
        id: '10_4',
        permission: 'access customer_management-setup',
        children: [
          {
            title: 'Menu.CRM.Settings.General',
            id: '10_4_1',
            page: 'CustomerGeneralSettings',
            permission: 'access customer_management-setup',
            mask: 'cust003',
          },
          {
            title: 'Menu.CRM.Settings.Levels',
            id: '10_4_2',
            page: 'CustomerLevelsSettings',
            permission: 'access customer_management-setup',
            mask: 'cust006',
          },
          {
            title: 'Menu.CRM.Settings.States',
            id: '10_4_3',
            page: 'CustomerStatesList',
            permission: 'access customer_management-setup',
            mask: 'cust007', // add/detail cez CustomerStatesAdd -> cust009
          },
          {
            title: 'Menu.CRM.Settings.ExecutionSteps',
            id: '10_4_3_1',
            page: 'CustomerStepsList',
            permission: 'access customer_management-setup',
            mask: 'cust023', // add/detail cez CustomerStepsAdd -> cust024
          },
          {
            title: 'Menu.CRM.Settings.TaskTemplates',
            id: '10_4_3_2',
            page: 'TaskTemplateList',
            props: { templateContext: 'crm' },
            permission: 'access customer_management-setup',
            mask: 'cust025', // add/detail cez TaskTemplateAdd -> cust026
          },
          {
            title: 'Menu.CRM.Settings.Traders',
            id: '10_4_4',
            page: 'CustomerTradersList',
            permission: 'access customer_management-setup',
            mask: 'cust008', // add/detail cez CustomerTradersAdd -> cust010
          },
        ],
      },
    ],
  },
  {
    title: 'ServisAPP',
    id: '7',
    icon: ServiceIcon,
    permission: ['access service_task', 'access service_task-complete-list', 'access service_task-setup'],
    children: [
      {
        title: 'PreviewServiceTask',
        id: '7_6',
        page: 'PreviewServiceTask',
        mask:'intr011'
      },
      {
        title: 'ServiceTaskAdd',
        id: '7_2',
        page: 'ServiceTaskAdd',
        mask:'intr002'
      },
      {
        title: 'ServiceTaskList',
        id: '7_3',
        page: 'ServiceTaskList',
        mask:'intr003'
      },
      {
        title: 'ServiceTaskAllList',
        id: '7_5',
        permission: 'access service_task-complete-list',
        page: 'ServiceTaskAllList',
        mask:'intr010'
      },
      {
        title: 'Common.Settings',
        id: '7_4',
        permission: 'access service_task-setup',
        children: [
          {
            title: 'ServiceGeneralSettings',
            id: '7_4_4',
            page: 'ServiceGeneralSettings',
            mask:'intr012'
          },
          {
            title: 'TaskTemplateList',
            id: '7_4_1',
            page: 'TaskTemplateList',
            mask:'intr008' //add 009
          },
          {
            title: 'ServiceUsersSettings',
            id: '7_4_2',
            page: 'ServiceUsersSettings',
            mask:'intr005'
          },
          {
            title: 'ServiceStateList',
            id: '7_4_3',
            page: 'ServiceStateList',
            mask:'intr006' //add 007
          },
        ]
      },
    ],
  },
  {
    title: 'GlobalSettings',
    id: '6',
    icon: settingsIcon,
    permission: ['access settings', 'access users', 'access maintenance', 'access company settings'],
    children: [
        {
          title: 'Menu.Global.General',
          id: '6_1',
          permission: ['access settings', 'access maintenance'],
          children: [
            {
              title: 'Menu.Global.DepartmentList',
              id: '6_1_1',
              page: 'DepartmentList',
              permission: 'access settings',
              mask:'gset001'
            },
            {
              title: 'MachineList',
              id: '6_1_5',
              page: 'MachineList',
              permission: 'access maintenance',
              mask:'gset013'
            },
            {
              title: 'MachineTypeList',
              id: '6_1_6',
              page: 'MachineTypeList',
              permission: 'access maintenance',
              mask:'gset015'
            },
            {
              title: 'BusinessPartnerList',
              id: '6_1_3',
              page: 'BusinessPartnerList',
              permission: 'access settings',
              mask:'gset007'
            },
            {
              title: 'Menu.Global.BusinessData',
              id: '6_1_8',
              permission: 'access settings',
              children: [
                {
                  title: 'Menu.Global.BusinessData.ByCompany',
                  tabCompoundFromParent: true,
                  page: 'OtkCompanyStatisticsList',
                  id: '6_1_8_1',
                  mask: 'gset018'
                },
                {
                  title: 'Menu.Global.BusinessData.ByPeriod',
                  tabCompoundFromParent: true,
                  page: 'OtkCompanyStatisticsPeriodList',
                  id: '6_1_8_2',
                  mask: 'gset020'
                },
              ],
            },
            {
              title: 'ChecklistHolidayList',
              id: '6_1_9',
              page: 'ChecklistHolidayList',
              permission: 'access settings',
              mask: 'gset021'
            },
          ],
        },
        {
          title: 'Menu.Global.Personnel',
          id: '6_2',
          permission: 'access users',
          children: [
            {
              title: 'EmployeeList',
              id: '6_1_2',
              page: 'EmployeeList',
              permission: 'access users',
              mask:'gset003'
            },
            {
              title: 'UserList',
              id: '6_2_1',
              page: 'UserList',
              permission: 'access users',
              mask:'gset005'
            },
            {
              title: 'RoleList',
              id: '6_2_2',
              page: 'RoleList',
              permission: 'access users',
              mask:'gset011'
            },
          ],
        },
        {
          title: 'Menu.Global.CompanySection',
          id: '6_3',
          permission: ['access company settings', 'access settings'],
          children: [
            {
              title: 'Menu.Global.CompanySection.DataAndPrint',
              id: '6_3_1',
              page: 'CompanySettings',
              permission: 'access company settings',
              mask: 'gset022',
            },
            {
              title: 'Units',
              id: '6_3_2',
              page: 'UnitsSettings',
              permission: 'access settings',
              mask: 'gset017'
            },
          ],
        },
        
      ],
  },
];
